import { Drawer, Input } from 'antd';
import {
    SearchOutlined,
    MessageOutlined,
    PictureOutlined,
    AppstoreOutlined,
    ShoppingOutlined,
    ClockCircleOutlined,
    TagOutlined,
    MailOutlined,
    PhoneOutlined,
    UserOutlined,
    QuestionOutlined
} from '@ant-design/icons';

const STEP_OPTIONS = [
    {
        category: 'BASIC CONTENT',
        items: [
            {
                type: 'text',
                icon: <MessageOutlined />,
                iconClass: 'purple',
                title: 'Text Message',
                description: 'Send a simple message or emoji'
            },
            {
                type: 'image',
                icon: <PictureOutlined />,
                iconClass: 'blue',
                title: 'Image',
                description: 'Send visual content to users'
            }
        ]
    },
    {
        category: 'INTERACTIVE ELEMENTS',
        items: [
            {
                type: 'button',
                icon: <AppstoreOutlined />,
                iconClass: 'purple',
                title: 'Button Template',
                description: 'Add buttons for quick user choices'
            },

        ]
    },
    {
        category: 'LOGIC & FLOW',
        items: [
            {
                type: 'delay',
                icon: <ClockCircleOutlined />,
                iconClass: 'orange',
                title: 'Smart Delay',
                description: 'Wait before performing the next action'
            },
            {
                type: 'tag',
                icon: <TagOutlined />,
                iconClass: 'purple',
                title: 'Tag Contact',
                description: 'Add tags to segment and organize contacts'
            }
        ]
    },
    {
        category: 'LEAD GENERATION',
        items: [
            {
                type: 'email',
                icon: <MailOutlined />,
                iconClass: 'green',
                title: 'Capture Email',
                description: 'Request and validate email address',
                waitsForResponse: true
            },
            {
                type: 'phone',
                icon: <PhoneOutlined />,
                iconClass: 'green',
                title: 'Capture Phone',
                description: 'Request phone number with validation',
                waitsForResponse: true
            },
            {
                type: 'name',
                icon: <UserOutlined />,
                iconClass: 'green',
                title: 'Capture Name',
                description: 'Request user\'s full name',
                waitsForResponse: true
            },
            {
                type: 'custom_input',
                icon: <QuestionOutlined />,
                iconClass: 'green',
                title: 'Custom Input',
                description: 'Ask a custom question',
                waitsForResponse: true
            }
        ]
    }
];

export default function AddStepModal({ open, onClose, onAdd }) {
    return (
        <Drawer
            title="Add Step"
            placement="right"
            open={open}
            onClose={onClose}
            width={400}
            className="add-step-modal"
        >
            <Input
                placeholder="Search automation steps..."
                prefix={<SearchOutlined style={{ color: '#bbb' }} />}
                style={{ marginBottom: 24 }}
            />

            <div className="step-categories">
                {STEP_OPTIONS.map((category) => (
                    <div key={category.category} className="step-category">
                        <h4>{category.category}</h4>
                        {category.items.map((item) => (
                            <div
                                key={item.type}
                                className="step-option"
                                onClick={() => !item.comingSoon && onAdd(item.type)}
                                style={{
                                    opacity: item.comingSoon ? 0.6 : 1,
                                    cursor: item.comingSoon ? 'not-allowed' : 'pointer'
                                }}
                            >
                                <div className={`step-option-icon ${item.iconClass}`}>
                                    {item.icon}
                                </div>
                                <div className="step-option-text">
                                    <h5>{item.title}</h5>
                                    <p>{item.description}</p>
                                    {item.waitsForResponse && (
                                        <span style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 4,
                                            background: '#e6f7ff',
                                            color: '#1890ff',
                                            padding: '2px 8px',
                                            borderRadius: 4,
                                            fontSize: 11,
                                            fontWeight: 500,
                                            marginTop: 4
                                        }}>
                                            ⏳ Waits for user response
                                        </span>
                                    )}
                                </div>
                                {item.comingSoon && (
                                    <span className="coming-soon-tag">COMING SOON</span>
                                )}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </Drawer>
    );
}
